import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Loading } from "../lib/components/Loading";
import { CError } from "../common/CError";
const DisplayHtmlContext = ({ url, errorMessage }) => {
    const [content, setContent] = useState("");
    const [loading, setloading] = useState(false);
    const [error, setError] = useState(undefined);
    useEffect(() => {
        const getContent = async () => {
            try {
                setloading(true);
                setError(undefined);
                const result = await fetch(url);
                if (!result.ok) {
                    setloading(false);
                    setError(errorMessage);
                    return;
                }
                const text = await result.text();
                setContent(text);
                setloading(false);
            }
            catch {
                setloading(false);
                setError(errorMessage);
            }
        };
        getContent();
    }, [errorMessage, url]);
    if (loading) {
        return (_jsx("div", { className: "htmlcontentview loading", children: _jsx(Loading, {}) }));
    }
    if (error !== undefined) {
        return (_jsx("div", { className: "htmlcontentview error", children: _jsx(CError, { error: error }) }));
    }
    return (_jsx("div", { className: "htmlcontentview content flex-fill", dangerouslySetInnerHTML: { __html: content } }));
};
export default DisplayHtmlContext;
